import { useQuery } from "@tanstack/react-query";
import { billingService } from "@/services/api/billing.service";
import { useAuth } from "@/hooks/useAuth.hook";

export function useProAccess() {
  const { firebaseUser } = useAuth();

  const query = useQuery({
    queryKey: ["billing", "status"],
    queryFn: () => billingService.getStatus(),
    enabled: Boolean(firebaseUser),
    staleTime: 60_000,
  });

  return {
    isPro: query.data?.isPro ?? false,
    subscription: query.data?.subscription,
    prices: query.data?.prices,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
